export const topics = [
  {
    id: "variety-editing-debate",
    title: "综艺剪辑引发讨论：观众到底在争什么？",
    categoryId: "topics",
    categoryName: "吃瓜话题",
    excerpt:
      "同一期节目，有人觉得剪辑节奏拖沓，有人觉得信息量刚好。围绕剪辑的争论，其实是观众在看什么这件事上出现了分歧。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20editorial%20illustration%20of%20a%20crowded%20chat%20interface%20with%20glowing%20orange%20notification%20badges%20on%20a%20soft%20cream%20background%20geometric%20shapes%20no%20text%20no%20people%20harmonious%20amber%20and%20clay%20color%20palette&width=800&height=500&seq=gossip-topic-01&orientation=landscape",
    heat: 9820,
    comments: 412,
    time: "2 小时前",
    author: "编辑小满",
    tags: ["综艺", "剪辑", "讨论"],
    featured: true,
    content: [
      {
        heading: "争议是怎么烧起来的",
        paragraphs: [
          "最新一期节目播出后，讨论区里最先冒出来的并不是嘉宾表现，而是剪辑。有瓜友截图对比预告与正片，认为关键片段被放在了下一期，正片节奏因此显得松散。",
          "另一派则觉得这种安排是为了留住悬念，属于常规操作。两边的出发点其实都不在剪辑本身，而在对观看体验的期待不同：一方想看完整表达，一方更在意话题延续。",
        ],
      },
      {
        heading: "观众真正在意的三件事",
        paragraphs: [
          "第一是信息完整度。观众愿意花时间看长内容，前提是别把已经拍好的东西藏起来。第二是节奏，铺垫太久会劝退路人。第三是公平感，谁被给了镜头、谁被剪掉，很容易被解读成态度。",
          "把这三件事拆开看，会发现大多数争论并不矛盾：想要完整、想要流畅、想要公平，本来就可以同时成立，只是当期的取舍让三者无法兼得。",
        ],
      },
      {
        heading: "瓜友留言里的共识",
        paragraphs: [
          "评论区里点赞最高的一条写着：与其猜剪辑动机，不如直接说清楚哪些内容会在加更里出现。透明一点，争议就少一半。",
          "这条留言下面很快盖起了高楼。有人补充，节目组其实可以在片尾用一句话预告，成本极低；也有人认为观众的耐心也是有限资源，留悬念需要克制。",
        ],
      },
    ],
  },
  {
    id: "drama-ending-divide",
    title: "热播剧结局争议持续发酵，口碑为何两极分化",
    categoryId: "events",
    categoryName: "热点事件",
    excerpt:
      "收官当晚评分曲线剧烈波动，有人称为神来之笔，有人说前二十集白看了。同一个结局，为什么评价能差这么远？",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20a%20film%20reel%20and%20floating%20star%20ratings%20on%20a%20cream%20background%20layered%20paper%20cut%20style%20no%20text%20no%20people%20harmonious%20amber%20and%20deep%20red%20color%20palette&width=800&height=500&seq=gossip-topic-02&orientation=landscape",
    heat: 8640,
    comments: 356,
    time: "5 小时前",
    author: "编辑阿柚",
    tags: ["剧集", "结局", "口碑"],
    featured: true,
    content: [
      {
        heading: "一个结局，两种读法",
        paragraphs: [
          "支持者认为结局把前面埋下的伏笔一次性收拢，主角的选择符合人物成长逻辑，留白也让回味更久。反对者的理由同样直接：支线没有交代，感情线推进过快，像是为了赶时长。",
          "分歧的核心在于，这部剧前期把自己包装成强情节类型，观众带着解谜预期进入，最后却收到了一个偏文艺的收尾。预期错位，评价自然分叉。",
        ],
      },
      {
        heading: "评分曲线说明了什么",
        paragraphs: [
          "有趣的是，播出后 6 小时是评分最低点，随后缓慢回升。这说明第一波评价来自最投入的核心观众，他们的失望最直接；而回补的分数来自后知后觉的路人，他们反而更容易接受开放式结尾。",
          "这种现象在近两年的剧集里越来越常见，也提醒我们：开播时的宣传口径，会直接影响观众用什么标准打分。",
        ],
      },
      {
        heading: "讨论区里的理性声音",
        paragraphs: [
          "有位瓜友把自己的观剧笔记整理成长图，逐条标注哪些伏笔回收了、哪些没回收，评论区风向随之缓和了不少。摆事实比喊口号有用，这在剧集讨论里尤其成立。",
          "也有人提出，与其争论好坏，不如分成两种推荐语：喜欢慢收尾的可以冲，冲着爽感来的建议缓一缓。这种说法被大量点赞。",
        ],
      },
    ],
  },
  {
    id: "concert-ticket-rush",
    title: "演唱会门票秒空背后：抢票难到底难在哪",
    categoryId: "events",
    categoryName: "热点事件",
    excerpt:
      "开票三十秒售罄，转头二手平台上出现加价票。抢票到底难在供不应求，还是难在流程本身？瓜友总结了几个关键环节。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20concert%20stage%20lights%20and%20ticket%20stubs%20arranged%20in%20a%20fan%20on%20a%20cream%20background%20editorial%20poster%20art%20no%20text%20no%20people%20harmonious%20amber%20and%20crimson%20color%20palette&width=800&height=500&seq=gossip-topic-03&orientation=landscape",
    heat: 7410,
    comments: 289,
    time: "昨天",
    author: "编辑老白",
    tags: ["演出", "票务", "热点"],
    featured: false,
    content: [
      {
        heading: "供不应求是前提，但不是全部",
        paragraphs: [
          "热门场次的座位数就那么多，需求却可能是十倍以上，秒空本身并不奇怪。真正让瓜友不满的，是排队进度条走到 90% 时突然被要求重新登录。",
          "流程体验的断裂，会把「买不到」从市场问题变成情绪问题。这也是为什么每次开票后，讨论区最热的帖子往往和规则有关，而不是和演出本身有关。",
        ],
      },
      {
        heading: "三个容易被忽略的环节",
        paragraphs: [
          "第一是实名与转赠规则。规则越复杂，普通观众越容易在填写环节出错。第二是分批放票，如果批次间隔不透明，会被误认为有内部渠道。第三是候补机制，有没有候补决定了大家是否愿意守在原地。",
          "把这三件事讲清楚，能挡掉相当一部分误会。很多争议不是因为规则严格，而是因为规则在开票前一小时才公布。",
        ],
      },
      {
        heading: "瓜友的实用建议",
        paragraphs: [
          "讨论区置顶了一份抢票清单：提前完成实名、绑定支付方式、准备两台设备、开票前十分钟登录。评论区补充说，最重要的是别在二手平台冲动下单，价格往往在开演前一周回落。",
          "这些建议未必能提高中签率，但至少能减少因为操作失误而错过的情况。",
        ],
      },
    ],
  },
  {
    id: "endorsement-logic",
    title: "明星代言的商业逻辑，瓜友怎么看",
    categoryId: "opinion",
    categoryName: "瓜友观点",
    excerpt:
      "同一个品牌一年换了三次代言人，讨论区吵成一片。代言到底是看流量、看调性，还是看长期合作？我们整理了几种常见观点。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20a%20handshake%20icon%20and%20rising%20bar%20chart%20made%20of%20soft%20blocks%20on%20a%20cream%20background%20minimal%20editorial%20art%20no%20text%20no%20people%20harmonious%20amber%20and%20brown%20color%20palette&width=800&height=500&seq=gossip-topic-04&orientation=landscape",
    heat: 6120,
    comments: 231,
    time: "昨天",
    author: "编辑小满",
    tags: ["代言", "商业", "观点"],
    featured: false,
    content: [
      {
        heading: "观点一：短期看声量",
        paragraphs: [
          "支持这一派的瓜友认为，品牌签下代言人，首要目标是让新品被看见。短期内话题度高的合作对象，能迅速把产品推上讨论榜，这在快消行业尤其常见。",
          "但他们也承认，声量来得快去得也快，如果产品本身没有延续性，代言官宣当天的热度就是峰值。",
        ],
      },
      {
        heading: "观点二：长期看调性",
        paragraphs: [
          "另一派更看重匹配度。他们认为真正有效的代言，是人选和品牌气质互相加成，用户看到广告不会觉得别扭。这类合作往往一签就是两三年，出镜形式也更克制。",
          "讨论区有人做了个小统计：连续合作三年以上的案例，复购讨论度明显更稳。当然样本有限，只能算一个有趣的观察。",
        ],
      },
      {
        heading: "还有第三种解读",
        paragraphs: [
          "也有瓜友提出，换代言人未必是策略摇摆，可能只是品牌在不同产品线做区隔。大众线要声量，高端线要质感，两条线本来就不该用同一套逻辑评判。",
          "这个说法让讨论区的火气小了不少。把前提说清楚，很多争论其实根本不存在。",
        ],
      },
    ],
  },
  {
    id: "reality-show-lineup",
    title: "网综嘉宾阵容官宣，讨论区先吵翻了",
    categoryId: "circle",
    categoryName: "圈内动态",
    excerpt:
      "节目还没播，阵容海报已经被逐帧分析。新老搭配是惊喜还是保守？瓜友围绕「化学反应」聊了整整一个晚上。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20a%20microphone%20on%20a%20small%20round%20stage%20surrounded%20by%20abstract%20audience%20dots%20on%20a%20cream%20background%20no%20text%20no%20people%20harmonious%20amber%20and%20clay%20color%20palette&width=800&height=500&seq=gossip-topic-05&orientation=landscape",
    heat: 5580,
    comments: 198,
    time: "2 天前",
    author: "编辑阿柚",
    tags: ["网综", "阵容", "官宣"],
    featured: false,
    content: [
      {
        heading: "官宣海报里的信息量",
        paragraphs: [
          "有瓜友把海报排版拿出来分析，认为站位的紧凑程度暗示了分组方式。也有人泼冷水：海报多是设计稿，和实际拍摄顺序关系不大，不必过度解读。",
          "这种「放大镜式」观察本身就是吃瓜的一部分，只是需要区分哪些是线索、哪些是脑补。",
        ],
      },
      {
        heading: "新老搭配的老问题",
        paragraphs: [
          "老面孔熟悉流程、能控场，新面孔带来意外感，但磨合期往往需要两三期。观众的耐心通常也只给两期，这就形成了一个尴尬的时间差。",
          "讨论区里有人提议，首期可以做得更轻量，先让大家熟悉彼此，再进入正式任务节奏。这条建议被不少人认同。",
        ],
      },
      {
        heading: "值得期待的地方",
        paragraphs: [
          "阵容里有一组跨界组合，是话题度最高的部分。不同领域的表达方式撞在一起，容易产生真实的互动，而不是流程化的客套。",
          "如果节目能少一点剧本痕迹，多一点真实反应，这档网综大概率会成为这个季度讨论度最高的节目之一。",
        ],
      },
    ],
  },
  {
    id: "remake-classic-debate",
    title: "老剧翻拍再来一轮，情怀与创新能否兼得",
    categoryId: "topics",
    categoryName: "吃瓜话题",
    excerpt:
      "又一部经典被宣布翻拍，评论区立刻分成两派。怀念原版和期待新解，真的只能选一个吗？",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20stacked%20vintage%20film%20frames%20overlapping%20with%20soft%20shadow%20on%20a%20cream%20background%20editorial%20magazine%20art%20no%20text%20no%20people%20harmonious%20amber%20and%20sepia%20color%20palette&width=800&height=500&seq=gossip-topic-06&orientation=landscape",
    heat: 4890,
    comments: 176,
    time: "2 天前",
    author: "编辑老白",
    tags: ["翻拍", "经典", "讨论"],
    featured: false,
    content: [
      {
        heading: "怀旧派的担心",
        paragraphs: [
          "反对翻拍的声音，多半不是排斥新版本，而是担心原版被重新解读后失去原来的味道。尤其是当年靠演员表演撑起来的角色，一旦换了人，滤镜就会碎。",
          "这种担心有道理。经典之所以经典，往往和它诞生的时代语境绑定，脱离语境复刻，容易变成空壳。",
        ],
      },
      {
        heading: "创新派的反驳",
        paragraphs: [
          "支持者认为，翻拍本身是一种传承。技术、审美、观众结构都变了，用今天的方式重讲一个老故事，可能让年轻观众第一次接触它。",
          "他们也不认同「翻拍必然毁经典」的说法，毕竟近十年也有翻拍口碑超过原版的案例，只是需要更明确的改编方向，而不是一比一复刻。",
        ],
      },
      {
        heading: "折中的第三种可能",
        paragraphs: [
          "讨论区里最被认可的方案是：保留核心人物关系，重写时代背景。既让老观众找到熟悉的骨架，也给新版本留出表达空间。",
          "听起来不难，但真正难的是克制。改编者需要忍住「我全都想改」的冲动，这恰恰是最考验功力的地方。",
        ],
      },
    ],
  },
  {
    id: "short-drama-boom",
    title: "短剧爆火之后，内容质量该往哪走",
    categoryId: "circle",
    categoryName: "圈内动态",
    excerpt:
      "从无人问津到遍地开花，短剧只用了一年多。热度退潮之前，从业者和观众都在重新思考一个问题：下一步靠什么留住人。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20vertical%20phone%20screens%20playing%20short%20clips%20with%20play%20buttons%20on%20a%20cream%20background%20geometric%20editorial%20art%20no%20text%20no%20people%20harmonious%20amber%20and%20clay%20color%20palette&width=800&height=500&seq=gossip-topic-07&orientation=landscape",
    heat: 5230,
    comments: 164,
    time: "3 天前",
    author: "编辑小满",
    tags: ["短剧", "内容", "行业"],
    featured: false,
    content: [
      {
        heading: "爆火阶段的三个特征",
        paragraphs: [
          "一是成本低、周期短，试错快；二是投流依赖强，前几秒必须抓住人；三是题材高度集中，爽点套路被反复使用，观众很快就能预测走向。",
          "这些特征让短剧快速铺开，也埋下了同质化的隐患。当用户能猜出下一秒的转折，付费意愿就会下降。",
        ],
      },
      {
        heading: "质量拐点已经出现",
        paragraphs: [
          "最近几个月，讨论区里对短剧的评价明显分化：一边是「看完就忘」，一边是少数作品开始被认真讨论剧本和表演。分化的背后，是观众对内容的要求在提高。",
          "有从业者在评论区留言说，现在拿到好剧本比拿到流量更重要，因为获客成本上涨，只有留得住人的内容才能回本。",
        ],
      },
      {
        heading: "接下来可能发生什么",
        paragraphs: [
          "比较稳妥的判断是，题材会继续细分，古装、悬疑、家庭等垂类各自沉淀受众；同时制作水准整体上移，粗制滥造会被自然淘汰。",
          "对观众来说，这未必是坏事。选择变多，踩雷变少，讨论也终于能聊到作品本身。",
        ],
      },
    ],
  },
  {
    id: "fan-culture-boundary",
    title: "粉丝应援文化观察：热情与边界怎么把握",
    categoryId: "opinion",
    categoryName: "瓜友观点",
    excerpt:
      "应援从线上走到线下，规模越来越大。支持与越界之间，那条线到底该划在哪里？瓜友给出了几种看法。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20glowing%20light%20sticks%20and%20abstract%20cheering%20crowd%20shapes%20on%20a%20cream%20background%20editorial%20poster%20art%20no%20text%20no%20people%20harmonious%20amber%20and%20crimson%20color%20palette&width=800&height=500&seq=gossip-topic-08&orientation=landscape",
    heat: 4470,
    comments: 152,
    time: "3 天前",
    author: "编辑阿柚",
    tags: ["应援", "文化", "观点"],
    featured: false,
    content: [
      {
        heading: "热情本身没有问题",
        paragraphs: [
          "喜欢一个人、愿意为作品花时间，是很正常的事。讨论区里绝大多数瓜友都认可这一点，反对的从来不是支持，而是支持的方式影响到了别人。",
          "比如占道、扰民、过度解读，这些才是争议的来源。把它们和「喜欢」分开看，讨论会理性很多。",
        ],
      },
      {
        heading: "边界的三条参考线",
        paragraphs: [
          "一是别影响公共秩序，活动规模要匹配场地承载能力。二是别把猜测当事实，未经证实的说法传播出去，伤害的可能是当事人。三是别强迫别人站队，喜欢不该变成压力。",
          "这三条线其实适用于所有公共讨论，放在应援场景里同样成立。",
        ],
      },
      {
        heading: "一个被反复提到的建议",
        paragraphs: [
          "评论区点赞很高的一条是：把精力放回作品。买票、看剧、讨论内容，这些是对创作者最直接的支持，也不容易引发争议。",
          "有位瓜友补充说，克制的支持往往更长久。热情会退潮，但作品留得下来。",
        ],
      },
    ],
  },
  {
    id: "annual-topics-vote",
    title: "年度盘点话题征集，瓜友票选最热讨论",
    categoryId: "topics",
    categoryName: "吃瓜话题",
    excerpt:
      "一年下来，哪个话题让你印象最深？我们发起了年度盘点征集，把提名权交给瓜友，结果比预想中更有意思。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20a%20trophy%20and%20ballot%20cards%20with%20check%20marks%20on%20a%20cream%20background%20minimal%20editorial%20art%20no%20text%20no%20people%20harmonious%20amber%20and%20brown%20color%20palette&width=800&height=500&seq=gossip-topic-09&orientation=landscape",
    heat: 3980,
    comments: 137,
    time: "4 天前",
    author: "编辑老白",
    tags: ["盘点", "投票", "话题"],
    featured: false,
    content: [
      {
        heading: "征集是怎么做的",
        paragraphs: [
          "我们在讨论区发了一个征集帖，请瓜友提名过去一年里「最想再聊一次」的话题，并附上一句理由。三天收到两百多条提名，覆盖面比编辑预想的更广。",
          "有意思的是，被提名最多的并不全是热度最高的，很多是「当时没聊透」的话题。",
        ],
      },
      {
        heading: "提名里出现的三个方向",
        paragraphs: [
          "一是行业变化类，比如内容形态的更替；二是作品讨论类，围绕某部剧或某档节目的争议；三是社区氛围类，关于怎么好好讨论本身。",
          "第三类提名让人意外，说明瓜友对讨论环境是有期待的，不只是来围观。",
        ],
      },
      {
        heading: "接下来怎么推进",
        paragraphs: [
          "我们会把提名整理成候选清单，开放投票，最终形成一份年度话题回顾。入选的话题会重新整理时间线，补充当时的瓜友高赞观点。",
          "如果你有想补上的提名，欢迎在讨论区留言，这一期我们都是参与者。",
        ],
      },
    ],
  },
];